import { WallFireIcon } from './WallFireIcon';

/**
 * author: Austin Andrews
 * id 436644E2-0AFD-47DE-A15F-EF6BD02C5F5A
 * name wall-fire
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wall-fire.svg
 * tags
 * - Device / Tech 
 */
export const FirewallIcon = WallFireIcon;
export default FirewallIcon